import React from "react";
import { IoMdCheckmark } from "react-icons/io";

function Department({ title = "Department Title", image }) {
  return (
    <div className='border border-blue-100 rounded-sm'>
      <div className='grid grid-cols-1 sm:grid-cols-2 h-auto sm:h-[26.5rem]'>
        <div>
          <img
            src={image}
            alt='thumbnail'
            className='w-full h-full object-cover'
          />
        </div>
        <div className='p-7 text-gray-500'>
          <h1 className='text-primary text-2xl'>{title}</h1>
          <p className='py-3'>203 Fake St. California, USA</p>
          <button className='bg-primary text-white px-2 rounded-sm mb-3'>
            22 Doctors
          </button>
          <p className='leading-7'>
            Far far away, behind the word mountains, far from the countries
            Vokalia and Consonantia, there live the blind texts.
          </p>
          <div>
            <div className='flex gap-2 items-center text-primary mb-1.5 text-sm'>
              <div>
                <IoMdCheckmark />
              </div>
              <div>
                <h1>Emergency</h1>
              </div>
            </div>
            <div className='flex gap-2 items-center text-primary mb-1.5 text-sm'>
              <div>
                <IoMdCheckmark />
              </div>
              <div>
                <h1>Laboratory</h1>
              </div>
            </div>
            <div className='flex gap-2 items-center text-primary mb-1.5 text-sm'>
              <div>
                <IoMdCheckmark />
              </div>
              <div>
                <h1>Dental</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Department;
